import { useEffect } from "react";
import styles from "../table.module.css";
import { setFilterValues } from "../../../../../Redux/Actions/VideoLibraryFilterAction";
import { useDispatch, useSelector } from "react-redux";
import { filterVideoLibraryDataTable } from "../../../../../Redux/Actions/VideoLibraryDataTableActions";
import CheckBox from "../../../../Checkbox/CheckBox";
import { FaRegCircle, FaCheckCircle } from "react-icons/fa";
const FilterWithPercentage = ({ item }) => {
  const dispatch = useDispatch();
  const { filterValues } = useSelector(
    (state) => state?.videoLibraryFilterData
  );
  const tableData = useSelector(
    (state) => state?.VideoLibraryDataTable?.tableData
  );
  const percentageContainerStyle = (el) => {
    return {
      border: "1px solid black",
      backgroundImage: `linear-gradient(to right,rgb(151, 238, 151) ${
        el.percentage
      }%,transparent ${Math.round(Number(el.percentage).toFixed(0))}%)`,
    };
  };

  useEffect(() => {
    filterValues?.length > 0
      ? filterVideoLibraryDataTable(dispatch, {
          filterConditions: filterValues,
          tableData: tableData,
        })
      : filterVideoLibraryDataTable(dispatch, []);
  }, [filterValues]);

  const handleChange = (isChecked, val) => {
    let newItem = {
      id: val?.mediaBreakdownId,
      value: val?.value,
      operator: "===",
      breakDownName: item?.breakDownName,
    };
    setFilterValues(
      dispatch,
      isChecked
        ? [...(filterValues || []), newItem]
        : filterValues?.filter((el) => el?.id !== val?.mediaBreakdownId)
    );
  };

  const checkSaveValues = (values) => {
    return values?.filter((item) => item?.mediaBreakdownId) || [];
  };

  return (
    <>
      {checkSaveValues(item?.values).length ? (
        <div className={styles.filterToolTip}>
          {checkSaveValues(item?.values)?.map((el) => (
            <div style={percentageContainerStyle(el)}>
              <div
                className="d-flex align-items-start padding-5 gap-10 lh-1"
                style={{
                  lineHeight: "1",
                  alignItems: "start",
                }}
              >
                <CheckBox
                  checkedIcon={
                    <FaCheckCircle
                      className="fs-23"
                      style={{
                        color: "#002244",
                      }}
                    />
                  }
                  defaultIcon={<FaRegCircle className="fs-23" />}
                  onChange={(checked) => {
                    handleChange(checked, el);
                  }}
                  checked={filterValues?.some(
                    (value) => value?.id === el?.mediaBreakdownId
                  )}
                />

                <div className={styles.percentageContainerTextContent}>
                  <span className="fs-16 semi-bold">{el.value}</span>
                  <span className="semi-bold fs-14">{`${el?.percentage} % (${
                    el?.count
                  } time${el?.count > 1 ? "s" : ""} used)`}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="semi-bold">
          Column Is Empty. Please Add Some Records & Save the Playlist. Then New
          Records Will Appear Here.
        </p>
      )}
    </>
  );
};

export default FilterWithPercentage;
